import { ServiceType } from "./service-type";
import { Unity } from "./unity";

export class PayService {
	id:number = 0;
	unity_id:number = 0;
	unity:Unity = new Unity();
	service_type_id:number = 0;
	service_type:ServiceType = new ServiceType();
	title:string = '-';
	identifier:string = '-';
	price:number = 0;
	iva:number = 0;
	initial_date:Date = new Date();
	final_date:Date = null;
	initial_kms:number = 1;
	final_kms:number = 0;
	extra_cost:number = 0;
	extra_description:string = '';
	active:boolean = true;
	notification_days:number = 0;
}